var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Sayfa bulunamadı.")])])}]

export { render, staticRenderFns }